module.exports = __webpack_public_path__ + "img/warning_icon.5795d155.svg";